/** Epic 93 — Assign Action panel copy and step labels (UX gating only). */

export const GROUPED_ASSIGN_ACTION_INTRO =
  'Assign an action owner if needed, then record or view the site control on the Safety Case. Field verification and follow-up stay on this review.';

export const GROUPED_ASSIGN_ACTION_OWNER_GATE_MESSAGE =
  'Assign an action owner before tracking follow-up on this review item.';

export const GROUPED_ASSIGN_ACTION_OWNER_SAVED_MESSAGE =
  'Action owner saved on this review item. Record or view the site control on the Safety Case.';

export const GROUPED_ASSIGN_ACTION_PLAN_SAVED_MESSAGE =
  'Site control is recorded. Complete field verification, then track follow-up status.';

export const GROUPED_ASSIGN_ACTION_FIELD_VERIFICATION_HELPER =
  'Record Confirmed, Fail, or N/A for each walkdown item. Closure stays blocked until all seven are answered.';

export const GROUPED_ASSIGN_ACTION_STEP3_HELPER =
  'Track whether corrective follow-up has started or finished.';

export const GROUPED_ASSIGN_ACTION_STEP_TITLES = {
  owner: 'Step 1: Assign action owner',
  plan: 'Site control',
  fieldVerification: 'Step 3: Field verification',
  followUpStatus: 'Step 4: Track follow-up status',
  acknowledge: 'Step 5: Acknowledge representative evidence',
} as const;
